export const meetingValidationRules = {
    "board-meeting-minutes": {
        requiredFields: [
            "Company Name",
            "CIN",
            "Meeting Number",
            "Date",
            "Time",
            "Venue/Mode",
            "Chairperson",
            "Directors Present (Name & Mode)",
            "Quorum (Yes/No)",
            "Agenda Item No.",
            "Agenda Title",
            "Resolution Text",
            "Time of Closure"
        ],
        allowedFields: [
            "Company Name",
            "CIN",
            "Meeting Number",
            "Date",
            "Time",
            "Venue/Mode",
            "Chairperson",
            "Directors Present (Name & Mode)",
            "Quorum (Yes/No)",
            "Leave of Absence Granted",
            "Invitees",
            "Agenda Item No.",
            "Agenda Title",
            "Resolution Text",
            "Any Other Business (Yes/No + Details)",
            "Notes",
            "Action Items",
            "Time of Closure"
        ],
        dateFields: ["Date"],
        timeFields: ["Time", "Time of Closure"],
        yesNoFields: [
            "Quorum (Yes/No)",
            "Any Other Business (Yes/No + Details)"
        ],
        numberFields: ["Agenda Item No."]
    },

    "committee-meeting-minutes": {
        requiredFields: [
            "Company Name",
            "CIN",
            "Committee Name",
            "Meeting Number",
            "Date",
            "Time",
            "Venue/Mode",
            "Chairperson of Committee",
            "Members Present (Name & Mode)",
            "Quorum (Yes/No)",
            "Agenda Item No.",
            "Agenda Title",
            "Resolution Text",
            "Time of Closure"
        ],
        allowedFields: [
            "Company Name",
            "CIN",
            "Committee Name",
            "Meeting Number",
            "Date",
            "Time",
            "Venue/Mode",
            "Chairperson of Committee",
            "Members Present (Name & Mode)",
            "Invitees",
            "Quorum (Yes/No)",
            "Agenda Item No.",
            "Agenda Title",
            "Resolution Text",
            "Notes",
            "Action Items",
            "Time of Closure"
        ],
        dateFields: ["Date"],
        timeFields: ["Time", "Time of Closure"],
        yesNoFields: ["Quorum (Yes/No)"],
        numberFields: ["Agenda Item No."]
    },

    "agm-minutes": {
        requiredFields: [
            "Company Name",
            "CIN",
            "Meeting Number",
            "Date",
            "Time",
            "Venue/Mode",
            "Chairperson",
            "Members Present (in person)",
            "Agenda Item No.",
            "Agenda Title"
        ],
        allowedFields: [
            "Company Name",
            "CIN",
            "Meeting Number",
            "Date",
            "Time",
            "Venue/Mode",
            "Chairperson",
            "Registered Office Address",
            "Type of Meeting (AGM/EGM)",
            "Members Present (in person)",
            "Proxies Present",
            "Corporate Representatives Present",
            "Quorum Present (Yes/No)",
            "Notice Date",
            "Notice Read (Yes/No)",
            "Auditor's Report Read (Yes/No)",
            "Agenda Item No.",
            "Agenda Title",
            "Agenda Type (Ordinary/Special Business)",
            "Resolution Type (Ordinary/Special)",
            "Resolution Text",
            "Result (Passed/Rejected)",
            "Time of Closure"
        ],
        dateFields: ["Date", "Notice Date"],
        timeFields: ["Time"],
        yesNoFields: [
            "Quorum Present (Yes/No)",
            "Notice Read (Yes/No)",
            "Auditor's Report Read (Yes/No)"
        ],
        numberFields: [
            "Members Present (in person)",
            "Proxies Present",
            "Corporate Representatives Present",
            "Agenda Item No."
        ]
    },

    "egm-minutes": {
        requiredFields: [
            "Company Name",
            "CIN",
            "Meeting Number",
            "Date",
            "Time",
            "Venue/Mode",
            "Chairperson",
            "Agenda Item No.",
            "Agenda Title"
        ],
        allowedFields: [
            "Company Name",
            "CIN",
            "Meeting Number",
            "Date",
            "Time",
            "Venue/Mode",
            "Chairperson",
            "Registered Office Address",
            "Type of Meeting (AGM/EGM)",
            "Members Present (in person)",
            "Proxies Present",
            "Corporate Representatives Present",
            "Quorum Present (Yes/No)",
            "Notice Date",
            "Notice Read (Yes/No)",
            "Auditor's Report Read (Yes/No)",
            "Agenda Item No.",
            "Agenda Title",
            "Resolution Type (Ordinary/Special)",
            "Resolution Text",
            "Result (Passed/Rejected)",
            "Time of Closure"
        ],
        dateFields: ["Date", "Notice Date"],
        timeFields: ["Time"],
        yesNoFields: [
            "Quorum Present (Yes/No)",
            "Notice Read (Yes/No)",
            "Auditor's Report Read (Yes/No)"
        ],
        numberFields: [
            "Members Present (in person)",
            "Proxies Present",
            "Corporate Representatives Present",
            "Agenda Item No."
        ]
    }
};